import React from "react";

import "./Header.scss";

const Header = () => {
    return (
        <header className="md-header">
            <h1 className="md-header__title">
                Todo React APP
                <br /> by Mirkodev
            </h1>
        </header>
    );
};

export default Header;
